// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const DEPARTMENT_BASE_URL = '/api/v1/wechat/departments';

/**
 * 获取部门列表
 * @param options 请求配置
 */
export async function getDepartmentList(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.Department[]>>(`${DEPARTMENT_BASE_URL}/`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 获取部门树形结构
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getDepartmentTree(
  params?: { parent_id?: number },
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.Department[]>>(`${DEPARTMENT_BASE_URL}/tree`, {
    method: 'GET',
    params: params || {},
    ...(options || {}),
  });
}

/**
 * 同步组织架构
 * @param data 同步参数
 * @param options 请求配置
 */
export async function syncDepartments(
  data?: { force_sync?: boolean },
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.SyncDepartmentResult>>(`${DEPARTMENT_BASE_URL}/sync`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data || {},
    ...(options || {}),
  });
}

